import { defineQuery, useQuery } from "@pinia/colada";

export const useMyLillopoints = defineQuery(() => {
  const { data: myLillopoints, isLoading, status, error } = useQuery<MyLillopoints, Error, MyLillopoints>({
    key: () => ["my_lillopoints"],
    query: async () => v.parse(myLillopointsSchema, await ajaxRequest<MyLillopoints>("get_my_lillopoints")),
    placeholderData: { items: [] },
    staleTime: 1000 * 60 * 60 * 24,
  });
  return { myLillopoints, isLoading, status, error };
});
